import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import clsx from 'clsx';
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import Button from '@/src/components/common/Elements/Button/Button';
import Editor from '@/src/components/common/Files/Editor/Editor';
import { updateCommentFromApi } from '@/src/reducers/project/comments/comments.actions.js';
import { cn } from '@/src/util/ui';

const Edit = ({ comment, onReplying, handleSelected, selected, className = '' }) => {
  const [state, setState] = useState({
    isFocused: false,
    previousComment: '',
    currentComment: '',
  });
  const dispatch = useDispatch();

  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      previousComment: comment.comment,
      currentComment: comment.comment,
    }));
  }, [comment]);

  const handleUpdate = () => {
    onReplying(null);

    if (handleSelected) {
      handleSelected({ id: comment.id, type: 'edit' });
    }
  };

  const handleSubmitUpdate = () => {
    dispatch(updateCommentFromApi(comment.id, state.currentComment)).then(() => {
      if (handleSelected) {
        handleSelected({ id: null, type: null });
      }
    });
  };

  const handleCancel = () => {
    setState((prevState) => ({ ...prevState, previousComment: '', currentComment: '' }));
    if (handleSelected) {
      handleSelected({ id: null, type: null });
    }
  };

  const handleInputChange = (value) => {
    setState((prevState) => ({ ...prevState, currentComment: value }));
  };

  const handleBlur = () => {
    setState((prevState) => ({ ...prevState, isFocused: false }));
  };

  if (comment.id === selected.id && selected.type === 'edit') {
    return (
      <div className="updateCommentContainer">
        <ClickAwayListener onClickAway={handleBlur}>
          <div className="form-group">
            <Editor
              classes={'fileComments update !tw-ml-0'}
              type={'update'}
              handleChange={handleInputChange}
              message={state.currentComment ? { comment: state.currentComment } : comment}
              isEnabled={state.currentComment !== state.previousComment}
            />

            <div className={clsx('actionContainer', 'tw-flex tw-items-center', 'tw-my-[5px]')}>
              {state.currentComment !== state.previousComment && (
                <Button
                  className={clsx('btn--save')}
                  buttonClassSettings={{ variant: 'secondary', size: 'sm' }}
                  onClick={handleSubmitUpdate}
                >
                  Save
                </Button>
              )}
              <Button
                className={clsx('btn--cancel')}
                buttonClassSettings={{ variant: 'filled_inverse', size: 'sm' }}
                onClick={handleCancel}
              >
                Cancel
              </Button>
            </div>
          </div>
        </ClickAwayListener>
      </div>
    );
  }

  return (
    <Button className={cn(className)} onClick={handleUpdate}>
      Edit
    </Button>
  );
};
export default Edit;
